module.exports = __webpack_public_path__ + "static/media/DATOS_PERSONALES_BLANCO.57aff09a.svg";